export default {
  "yunlinHealthWalk": "https://bit.ly/3Wv7CgM", // 雲林健康步道
  "leisureLearningPlatform": "https://bit.ly/4qwYgi6", // 樂齡健康學習平台
  "yunlinHigherEducationCaregiver": "https://bit.ly/3LfrH8j", // 雲林縣智慧校園親師生平台
  "nationalHealthAssistant": "https://bit.ly/4ofPrHW", // 國衛院健康小管家
  "kasuHakkaLanguage": "https://bit.ly/3JolfLO", // 詔安客語
  "aboriginalLanguage": "https://bit.ly/4oI76YC", // 原住民族語
  "storeManagementBackend": "https://bit.ly/4om0RKy", // 特店管理後台
  "onlineApplication": "https://bit.ly/49HiLlU", // 線上申辦
  "healthAndHappiness": "https://bit.ly/49FX0mq", // 心健康心幸福
  "guanYunZhang": "https://bit.ly/4q9VcYJ", // 關雲長
  "yunlinBus": "https://bit.ly/4oDYPFa", // 雲林公車
  "yunlinEc": "https://bit.ly/47dEYa4", // 雲林良品電商平台
  "yunlinCleaningCar": "https://bit.ly/433AhNy", // 雲林清潔車
  "yunlinRehabilitationBus": "https://bit.ly/4hDebaI", // 雲林復康巴士
  "airQuality": "https://bit.ly/3LyunOm", // 空氣品質
  "jointServiceCenter": "https://bit.ly/47Ozt1G", // 聯合服務中心
  "eventCalendar": "https://bit.ly/49s8kms", // 活動行事曆
  "agriculturalPlatform": "https://bit.ly/4ntqQOE", // 農業行動平台
  "yunlinShelterPlatform": "https://bit.ly/47tkFWN", // 雲林縣防空疏散避難平台
  "trafficInformation": "https://bit.ly/47fU3rI", // 路況資訊
  "slowTourYunlin": "https://bit.ly/4r5THuU", // 慢遊雲林
  "healthActivityParticipationPlatform": "https://bit.ly/45mw5cZ", // 健康活動參與平台
  "aboutYunlinCoin": "https://bit.ly/45eEOhm", // 關於雲林幣扭一下2.0
  "facebookFanPage": "https://bit.ly/4qsR3iB", // Facebook 粉絲專頁
  "rentEcoFriendlyUtensils": "https://bit.ly/4qt70p0", // 租借環保餐具
  "goToParkingDiscount": "https://bit.ly/3NsayGh" // 前往使用停車折抵
};
